var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isValue(-1))?_c('b-icon',{attrs:{"color":_vm.threshold[0].Color,"scale":"1","icon":"caret-down-fill"}}):(_vm.isValue(0))?_c('b-icon',{attrs:{"color":_vm.threshold[1].Color,"scale":"0.666","icon":"circle-fill"}}):(_vm.isValue(1))?_c('b-icon',{attrs:{"color":_vm.threshold[2].Color,"scale":"1","icon":"caret-up-fill"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }